// @ts-nocheck a6642aca
import { array } from '#packages/util';
import wixFormsConstants from '../../contact/wixForms/constants';
import * as wixFormsUtils from '../../contact/wixForms/utils';

const addForm = (structure) => {
  const form = wixFormsUtils.getFormWidget({
    layout: {
      width: 518,
      height: 110,
      x: 16,
      y: 476,
      scale: 1,
      rotationInDegrees: 0,
      anchors: [
        {
          distance: 507,
          originalValue: 778,
          type: 'BOTTOM_PARENT',
          locked: false,
          targetComponent: 'comp-im0kxzm0',
        },
      ],
      fixedPosition: false,
    },
    controllerType: wixFormsConstants.CONTROLLER_TYPES.GET_SUBSCRIBERS,
  });

  // add form to
  // components: [
  //     component_0: {
  //         components: [
  //             form,
  //             ...
  //         ]
  //     },
  // ]
  return {
    ...structure,
    components: array.immutableSplice(structure.components, 0, 1, {
      ...structure.components[0],
      components: array.immutableSplice(
        structure.components[0].components,
        0,
        0,
        form,
      ),
    }),
  };
};

export default (onDrop, onClick) => (item) => {
  onDrop = onDrop(wixFormsConstants.FormPreset.LIGHTBOX_SUBSCRIBE03);
  onClick = onClick(wixFormsConstants.FormPreset.LIGHTBOX_SUBSCRIBE03);

  return {
    ...item,
    onDrop,
    onClick,
    structure: addForm(item.structure),
  };
};
